var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LayersIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42548 8.18155L10.6109 2.43599C11.4058 1.87807 12.5939 1.87781 13.3891 2.43599L21.5745 8.18155C22.1413 8.57939 22.1419 9.41896 21.5758 9.81766L13.3903 15.5818C12.5949 16.1419 11.4054 16.1421 10.6097 15.5818L2.42424 9.81766C1.85806 9.41896 1.8587 8.57939 2.42548 8.18155ZM19.2672 15.047C19.2672 15.047 19.2239 15.0261 18.9508 14.8359C18.4984 14.521 18.3766 13.8711 18.6942 13.4224C19.0117 12.9738 19.6133 12.8992 20.1007 13.2111C20.3901 13.3963 21.3859 14.0782 21.5756 14.2379C22.1391 14.7123 22.1434 15.4661 21.5768 15.8618L13.3852 21.583C12.5893 22.1389 11.3989 22.1392 10.6025 21.583L2.41092 15.8618C1.84431 15.4661 1.88167 14.6817 2.41216 14.2379C2.60857 14.0736 3.65003 13.3761 3.93136 13.1803C4.38374 12.8653 5.00789 12.9738 5.32542 13.4224C5.64296 13.8711 5.53365 14.4901 5.08127 14.8051C4.89982 14.9314 4.72196 15.0552 4.72196 15.0552L11.7549 19.9599C11.8599 20.0333 12.1279 20.0332 12.2329 19.9599L19.2672 15.047ZM12.24 4.07297C12.1345 3.99892 11.8654 3.99898 11.76 4.07297L4.73549 9.00361L11.7612 13.9465C11.8662 14.0204 12.1339 14.0204 12.2388 13.9465L19.2573 9.00415L12.24 4.07297Z",
    fill: ""
  }));
}
export var LayersIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: LayersIconInner
  }, props));
};